<script>
  import { MDBDataTable } from "mdbsvelte";

  export let columns = [];
  export let data = [];

  // $: {
  //   let data_tmp = data;
  // }
</script>

<!-- <MDBDataTable responsive hover {columns} filter='source' proSelect {data} entriesOptions={[5, 12, 20, 50]} entries={12} pagesAmount={4} /> -->

<MDBDataTable hover {data} {columns} filter="office" proSelect searchTop searchBottom={false} />
